export const UPDATE_CITY_ID = "updateCityId";
